<template>
  <div class="p-4 bg-white rounded-lg" style="height: 1400px">
    <DataTable />
    <div style="height: 60px"></div>
  </div>
</template>

<script>
import DataTable from "@/own/components/customerService/callAssignment/DataTable.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "CallAssignment",
  components: { DataTable },

  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
